import Vue from "vue";
import "ant-design-vue/dist/antd.css"; // 或者 ant-design-vue/lib/button/style/css 加载 css 文件
import {
  Button,
  message,
  Modal,
  List,
  Avatar,
  Pagination,
  ConfigProvider,
  DatePicker,
  Table,
  Spin,
  Icon
} from "ant-design-vue";

Vue.use(Button);
Vue.use(message);
Vue.use(Modal);
Vue.use(List);
Vue.use(Avatar);
Vue.use(Pagination);
Vue.use(ConfigProvider);
Vue.use(DatePicker);
Vue.use(Table);
Vue.use(Spin);
Vue.use(Icon);

Vue.prototype.$message = message;

message.config({
  duration: 2, // 持续时间
  top: `100px`, // 到页面顶部距离
  maxCount: 3 // 最大显示数, 超过限制时，最早的消息会被自动关闭
});
